import React from 'react';
import NewsletterPage from './components/NewsletterPage';
import './App.css';

function App() {
  return <NewsletterPage />;
}

export default App;
